import React, { useState, useRef, useEffect, useContext } from "react";
import { Container, Grid, Image, Form, Icon, Button } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import { useHistory, NavLink } from "react-router-dom";
import atar_logo from "../../assets/home/atar_logo.png";
import "react-datepicker/dist/react-datepicker.css";
import four_1 from "../../assets/home/submit_img.png";
import { StarButton } from '../../components'

const Fourscreen1 = () => {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);
  const history = useHistory();
  
  return (
    <div className="container_bg clearall">
      <NavLink
        to="">
        <Image className="logo_img" src={atar_logo} />
      </NavLink>

      <div className="celeb_bg">

        <Image className="four_1" src={four_1} />
        <h4>{t("fourscreen.nomber")}</h4>
        <p>{t("fourscreen.para")}</p>
        <div className="clearall">
          <div className="fourbt">
            <StarButton background={'mainBg'} width="350px" title={t("fourscreen.btn")} onClickAction={() => history.push('/')} />
          </div>
        </div>

      </div>

    </div>
  );
};

export default Fourscreen1